.headerBox {
  align-items: center;
  justify-content: space-between;
}

.chordNameLabel {
  margin-right: var(--tuna-spacing-1);
}

.noteChip {
  margin: var(--tuna-spacing-1);
}

.tabs {
  margin-bottom: var(--tuna-spacing-2);
}

.fretboard {
  min-width: 500px;
}
